// @flow

import React, { Component } from "react"
import { connect } from "react-redux"
import styled from "styled-components"
import humanFormat from "human-format"
import { API_URL } from "../actions"
import _ from "lodash"

const STATE = {
  LOADING: "A carregar",
  ERROR: "Erro a enviar",
  IDLE: "Selecione ficheiro",
  OK: "Ficheiro enviado!",
}

const Root = styled.div`
  display: flex;
  flex-direction: row;

  font-size: 16px;
  font-weight: 500;
  color: #777777;
`

const Img = styled.img`
  cursor: pointer;
`

const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  margin-left: 20px;
  min-width: 120px;
  max-width: 150px;
`

const StatusInfo = styled.div`
  transition: all 0.5s;
  opacity: 0;
  height: 0px;
  font-size: 12px;
  ${ props => props.loading ? `
    opacity: 1;
    height: auto;
  ` : "" }
`

const ProgressBarBackground = styled.div`
  width: 100%;
  height: 4px;
  border-radius: 6px;
  background-color: rgba(152, 152, 152, 0.2);
  margin-top: 5px;
`
const ProgressBar = styled.div`
  height: 4px;
  border-radius: 6px;
  background-color: #989898;
`

const Upload = styled.div`
  display: flex;
  vertical-align: middle;
  flex-direction: column;
  height: 100%;
  &>label {
    margin: auto;
  }
  &>input {
    display: none;
  }
`

const toHuman = ( v: number ) => humanFormat( v, {
  scale: "binary",
  unit: "B",
} )

class FileUpload extends Component {
  props: {
    command: string,
    args: {},
    onCompleteOk: ?( result: [mixed] ) => void,
    auth: any,
    autoSend: ?boolean,
    disabled: boolean,
  }

  defaultProps = {
    autoSend: true,
  }

  state = {
    file: undefined,
    fileSize: 0,
    completedSize: 0,
    state: STATE.IDLE,
  }

  sendFileProgress = ( e: ProgressEvent ) => {
    // progress on transfers from the server to the client (downloads)
    if ( e.lengthComputable ) {
      this.setState( {
        ...this.state,
        fileSize: e.total,
        completedSize: e.loaded,
        state: STATE.LOADING,
      } )
    }
  }

  sendFileError = () => this.setState( {
    ...this.state,
    state: STATE.ERROR,
  } )

  sendFileOk = () => this.setState( {
    ...this.state,
    state: STATE.OK,
  } )

  sendFileCallCallback = e => {

    if ( e.target.readyState === XMLHttpRequest.DONE ) {
      let response
      try {
        response = JSON.parse( e.target.responseText )
        if ( e.target.status !== 200 || response.message !== "OK" ) {
          throw ""
        }
      } catch ( err ) {
        this.sendFileError()
        return
      }

      if ( this.props.onCompleteOk !== undefined && this.props.onCompleteOk !== null ) {
        this.props.onCompleteOk( response[ "result" ] )
      }
    }
  }

  inputOnChange = e => {
    const files = e.target.files // FIXME: Should allow multiple files
    if ( files.length === 0 ) {
      this.setState( {
        fileSize: 0,
        completedSize: 0,
        state: STATE.IDLE,
      } )
      return
    }
    const fileSize = _.reduce( files, ( sum, file ) => sum + file.size, 0 )
    this.sendFiles( files )
    this.setState( {
      fileSize,
      completedSize: 0,
      state: STATE.LOADING,
    } )
    e.target.value = ""
  }

  sendFiles ( files: [any] ) {
    const token = this.props.auth.token

    const formData = new FormData()
    _.each( files, file => formData.append( "files", file, file.name ) )
    formData.append( "token", token )
    formData.append( "query", JSON.stringify( {
      command: this.props.command,
      args: this.props.args,
    } ) )



    const xhr = new XMLHttpRequest()
    xhr.open( "POST", API_URL, true )
    xhr.upload.addEventListener( "progress", e => this.sendFileProgress( e ) )
    xhr.upload.addEventListener( "error", () => this.sendFileError() )
    xhr.upload.addEventListener( "abort", () => this.sendFileError() )
    xhr.upload.addEventListener( "load", () => this.sendFileOk() )
    xhr.onreadystatechange = this.sendFileCallCallback

    xhr.setRequestHeader( "authtoken", token )
    xhr.send( formData )
  }

  render () {
    const { state } = this
    const { disabled } = this.props
    const { fileSize, completedSize } = state
    return (
      <Root>
        <Upload>
          <label htmlFor={ disabled || "file-upload" }>
            <Img src="/assets/img/upload_icon.svg" alt=""
              style={{ cursor: disabled ? "default" : "pointer" }}/>
          </label>
          <input
            type="file"
            id="file-upload"
            onChange={this.inputOnChange}
            multiple
          />
        </Upload>
        <Info>
          <div>{this.state.state}</div>
          <StatusInfo loading={state.state !== STATE.IDLE}>
            <ProgressBarBackground>
              <ProgressBar style={( () => {
                let fileSizeSafe = Math.max( fileSize, 1 )
                let width = ( completedSize / fileSizeSafe ) * 100
                return {
                  width: width + "%",
                }
              } )()}>
              </ProgressBar>
            </ProgressBarBackground>
            {toHuman( this.state.completedSize )} / {toHuman( this.state.fileSize )}
          </StatusInfo>
        </Info>
      </Root>
    )
  }
}

const mapStateToProps = ( store ) => {
  return {
    auth: store.auth,
  }
}

export default connect( mapStateToProps, {} )( FileUpload )



// WEBPACK FOOTER //
// ./src/components/FileUpload.jsx